import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css } from '@mgmresorts/wcl-styled';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
var StyledModalContainer = styled.div.attrs(function (_ref) {
  var zIndex = _ref.zIndex;
  return {
    style: {
      zIndex: zIndex
    }
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  transition: opacity 0.5s;\n  will-change: opacity;\n\n  ", "\n"])), function (p) {
  return p.fullScreen ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          overflow-y: auto;\n          -webkit-overflow-scrolling: touch;\n        "]))) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          pointer-events: none;\n          display: flex;\n          align-items: center;\n        "])));
});
var StyledBackdrop = styled.div.attrs(function (_ref2) {
  var zIndex = _ref2.zIndex;
  return {
    style: {
      zIndex: zIndex
    }
  };
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  pointer-events: all;\n  top: 0;\n  left: 0;\n\n  // Offset it by scrollbar width.\n  // NOTE This is imperfect solution,\n  // because ideally we should detect if a scrollbar is actually visible,\n  // and only then add an offset here which is equal to the real scrollbar width.\n  //\n  // However, this would make the whole logic of Modal more complex\n  // (we would have to detect if a scrollbar is at the moment visible).\n  //\n  // This simplier workaround causes a small bug:\n  // clicking on the last ~20px of the viewport on backdrop\n  // doesn't close the modal - but this happens only\n  // for centered modals that aren't taller than the viewport.\n  //\n  // However, user is still able to close the modal by clicking on the close button,\n  // so it isn't a big pain for him in rare case when he encounters the issue.\n  right: 20px;\n\n  bottom: 0;\n\n  background: ", ";\n"])), function (p) {
  return p.debug ? 'rgba(255, 0, 0, 0.5)' : 'transparent';
});
var StyledModalContainerInner = styled.div.attrs(function (_ref3) {
  var zIndex = _ref3.zIndex;
  return {
    style: {
      zIndex: zIndex
    }
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  pointer-events: all;\n  margin: 0 auto;\n\n  ", "\n"])), function (p) {
  return p.fullScreen && p.verticalAlign === 'top' ? css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          min-width: 100%;\n          min-height: 100%;\n        "]))) : css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          width: 100%;\n          max-width: 100%;\n          max-height: 100%;\n          overflow-y: auto;\n          -webkit-overflow-scrolling: touch;\n          ", "\n        "])), p.verticalAlign === 'center' ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                margin: auto;\n              "]))) : css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                margin: auto auto 0 auto;\n              "]))));
});
var StyledModalContainerInner2 = styled.div.attrs(function (_ref4) {
  var zIndex = _ref4.zIndex;
  return {
    style: {
      zIndex: zIndex
    }
  };
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n\n  ", "\n"])), function (p) {
  return p.fullScreen && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      min-width: 100%;\n      min-height: 100%;\n    "])));
});
var StyledInner2Backdrop = styled.div.attrs(function (_ref5) {
  var zIndex = _ref5.zIndex;
  return {
    style: {
      zIndex: zIndex
    }
  };
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  background: ", ";\n"])), function (p) {
  return p.debug ? 'rgba(0, 0, 255, 0.5)' : 'transparent';
});
var StyledModalContainerInner3 = styled.div.attrs(function (props) {
  return {
    style: {
      zIndex: props.zIndex,
      marginTop: props.marginTop,
      marginBottom: props.marginBottom
    }
  };
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", "\n\n  ", "\n"])), function (p) {
  return p.height === '100%' && css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      min-height: 100%;\n    "])));
}, function (p) {
  return p.width === '100%' ? css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n          min-width: 100%;\n        "]))) : css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n          margin-left: auto;\n          margin-right: auto;\n          max-width: 100%;\n        "])));
});

export { StyledBackdrop, StyledInner2Backdrop, StyledModalContainer, StyledModalContainerInner, StyledModalContainerInner2, StyledModalContainerInner3 };
